import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * EmptyState - Reusable empty state component
 *
 * @param {Object} props
 * @param {React.Component} props.icon - Icon component (e.g., Trophy from lucide-react)
 * @param {string} props.title - Main heading text
 * @param {string} props.description - Description text
 * @param {string} [props.buttonText] - Optional button text
 * @param {Function} [props.onButtonClick] - Optional button click handler
 */
export default function EmptyState({
  icon: Icon,
  title,
  description,
  buttonText,
  onButtonClick
}) {
  const { theme } = useTheme();

  return (
    <div className="text-center py-12">
      {Icon && (
        <Icon className={`w-16 h-16 ${theme.textMuted} mx-auto mb-4`} />
      )}
      <h3 className={`text-lg font-medium ${theme.text} mb-2`}>{title}</h3>
      <p className={`${theme.textSecondary} mb-4`}>{description}</p>
      {buttonText && onButtonClick && (
        <button
          onClick={onButtonClick}
          className={`${theme.primary} px-6 py-2 rounded-lg font-medium ${theme.primaryHover} transition-colors`}
        >
          {buttonText}
        </button>
      )}
    </div>
  );
}
